import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import triggerAllApiEvents from 'owa-addins-events/lib/triggerAllApiEvents';
import { AppointmentComposeAdapter, getAdapter } from 'owa-addins-apis';
import { convertRecurrenceToAddinFormat } from 'owa-addins-recurrence';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getComposeHostItemIndex } from 'owa-addins-store';
import { OutlookEventDispId } from 'owa-addins-events/lib/schema/OutlookEventDispId';

export function triggerRecurrenceChangedEvent(itemId: string, recurrenceType: RecurrenceType) {
    const hostItemIndex = getComposeHostItemIndex(itemId);
    const adapter = getAdapter(hostItemIndex) as AppointmentComposeAdapter;
    if (adapter != null && adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
        const recurrence = convertRecurrenceToAddinFormat({
            recurrenceType,
            startTime: adapter.getStartTime(),
            endTime: adapter.getEndTime(),
            timeZone: adapter.getTimeZone(),
        });
        triggerAllApiEvents(hostItemIndex, OutlookEventDispId.RECURRENCE_CHANGED_EVENT, () => {
            return {
                recurrence,
            };
        });
    }
}
